











import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class SexSelect extends Vue {
  @Prop() print!: boolean
  @Prop() value!: string | number | null

  get sex() {
    const value = this.value?.toString()
    const number = Number.parseInt(value || '')
    return !Number.isNaN(number) ? number : null
  }

  set sex(raw) {
    const value =
      typeof this.value === 'string' && raw !== null ? raw.toString() : raw

    this.$emit('update:value', value)
  }

  get isValid() {
    return this.sex === 0 || this.sex === 1
  }
}
